// extracted by mini-css-extract-plugin
export default {"serviceItem_block":"Service_serviceItem_block__2ZOxc","icon_block":"Service_icon_block__1-sgo","text_block":"Service_text_block__m9E5p"};